export default __webpack_public_path__ + "static/media/capa-mulher.39ab7997.png";